export default {
  apiKey: 'AIzaSyD13XiEvg8yyRe9HS9OzTjC9wckQJ0h9MM',
  authDomain: 'nani-development-436807.firebaseapp.com',
  projectId: 'nani-development-436807',
  storageBucket: 'nani-development-436807.firebasestorage.app',
  messagingSenderId: '86517502190',
  appId: '1:86517502190:web:aff0d13d9da933904723ff',
};
